export default {
  mutationPolicies(state, payload) {
    if (typeof payload.tab !== "undefined" && payload.tab !== null) {
      state.policies[payload.tab] = payload.responseData;
    } else {
      state.policies = payload;
    }
  },
  mutationPoliciesMeta(state, payload) {
    state.policiesMeta = payload;
  },
  mutationFiles(state, payload) {
    if (typeof payload.tab !== "undefined" && payload.tab !== null) {
      state.files[payload.tab] = payload.responseData;
    } else {
      state.files = payload;
    }
  },
  mutationPolicy(state, payload) {
    state.policy = payload;
  },
  mutationClaims(state, payload) {
    if (typeof payload.tab !== "undefined" && payload.tab !== null) {
      state.claims[payload.tab] = payload.responseData;
    } else {
      state.claims = payload;
    }
  },
  mutationClaimsMeta(state, payload) {
    state.claimsMeta = payload;
  },
  mutationListClaimsHistoriesClaim(state, payload) {
    state.claimsHistoriesClaim = payload;
  },
  mutationClaim(state, payload) {
    state.claim = payload;
  },
  mutationPartners(state, payload) {
    state.partners = payload;
  },
  mutationProducts(state, payload) {
    state.products = payload;
  },
  mutationProductCategories(state, payload) {
    state.productCategories = payload;
  },
  mutationUploadProgress(state, payload) {
    state.uploadProgress = payload;
  },
};
